// src/Components/Drawer/InfoTab/RenderSelect.js

import React from 'react';
import { Box, Typography, FormControl, Select, MenuItem } from '@mui/material';

const DARK_BLUE = '#00008B';
const ORANGE_COLOR = '#FF9900';

const styles = {
  fieldContainer: { display: 'flex', flexDirection: 'column', width: '100%' },
  label: {
    color: DARK_BLUE,
    fontWeight: 'bold',
    fontSize: '0.65rem',
    textTransform: 'uppercase',
    marginBottom: '0px',
    marginLeft: '2px',
    lineHeight: 1.2,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  valueBox: {
    borderRadius: '4px',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 4px',
    overflow: 'hidden',
    transition: 'background-color 0.3s ease',
    border: `1px solid ${ORANGE_COLOR}`,
  },
  input: {
    border: 'none',
    outline: 'none',
    width: '100%',
    backgroundColor: 'transparent',
    fontSize: '0.8rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: DARK_BLUE,
    padding: 0,
    margin: 0,
  },
};

export const RenderSelect = ({
  label,
  editValue,
  viewText,
  isEditing,
  onChange,
  options,
}) => {
  const safeValue = options.some((opt) => opt.id === editValue) ? editValue : '';
  return (
    <Box sx={styles.fieldContainer}>
      <Typography sx={styles.label}>{label}</Typography>
      <Box
        sx={{
          ...styles.valueBox,
          backgroundColor: isEditing ? '#E3F2FD' : '#fff',
          padding: 0,
        }}>
        {isEditing ? (
          <FormControl fullWidth variant='standard'>
            <Select
              value={safeValue}
              onChange={(e) => onChange(e.target.value)}
              disableUnderline
              displayEmpty
              sx={{
                fontSize: '0.8rem',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                color: DARK_BLUE,
                paddingLeft: '4px',
                '& .MuiSelect-select': { py: '2px' },
              }}
              MenuProps={{ sx: { zIndex: 100020 } }}>
              {' '}
              {/* AMENDED: Elevated to 100020 */}
              <MenuItem value='' disabled>
                Select {label}
              </MenuItem>
              {options.map((opt) => (
                <MenuItem key={opt.id} value={opt.id} sx={{ fontSize: '0.8rem' }}>
                  {opt.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Typography
            sx={{
              ...styles.input,
              padding: '0 4px',
              display: 'flex',
              alignItems: 'center',
              minHeight: '22px',
            }}>
            {viewText || ''}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
